import { Component, Input, OnInit } from '@angular/core';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-loader-main',
    templateUrl: './loader-main.component.html',
    styleUrls: ['./loader-main.component.scss'],
})
export class LoaderMainComponent implements OnInit {
    @Input() loaderMessageOptional: string;

    loaderMessage: string;
    loader: boolean;
    activeLoaders: number;
    showImageLoader: boolean;

    // fuseShow: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(private loaderService: LoaderService) {
        this.loaderService.loaderMessage.subscribe((loaderMessage) => (this.loaderMessage = loaderMessage));
        this.loaderService.loader.subscribe((loader) => (this.loader = loader));
        this.loaderService.activeLoaders.subscribe((activeLoaders) => (this.activeLoaders = activeLoaders));
        this.loaderService.showImageLoader.subscribe((showImageLoader) => (this.showImageLoader = showImageLoader));
    }

    ngOnInit() {}
}
